import { onApiError } from "../error"
import { state } from "../state"
import { post } from "./client"

/**
 * @param {string} imsi 
 * @param {string} name 
 * @returns {Promise<FarmcamSim>}
 */
async function registerFarmcamSim(imsi, name) {
    const res = await post(`/users/${(await state.getActiveUser()).Id}/farmcam-sims`, {
        body: JSON.stringify({
            Imsi: imsi,
            Name: name,
        })
    })

    if (!res.ok) throw await onApiError(res)
    return res.json()
}

export {
    registerFarmcamSim
}